import $ from 'jquery';
import GoogleMapsLoader from './GoogleMapsLoader.mjs';
import config from '../config.mjs';
import {getStoreUrl} from '../utilities/store-url.mjs';

export class Map {
  /**
   * @param {Window.jQuery|HTMLElement|*} $node HTML element, in which the map
   *                                            is initialised
   * @returns {Map}
   */
  constructor($node = undefined) {
    this.$node = $node || $('#map-wrapper');

    if (this.$node.length < 1) {
      return this;
    }

    try {
      (async () => {
        const {Map} = await GoogleMapsLoader.importLibrary('maps');
        const mapsCore = await GoogleMapsLoader.importLibrary('core');
        this.mapsCore = mapsCore;
        this.markers = [];
        this.bounds = new mapsCore.LatLngBounds();
        this.googleMap = new Map(this.$node.get(0), {
          center: {lat: 51.2, lng: 10.4}, // By default center of Germany
          zoom: 5,
          mapTypeControl: true,
          panControl: true,
          zoomControl: true,
          streetViewControl: false,
          mapId: 'EF_MAP_ID',
        });

        return this;
      })();
    } catch (exception) {
      console.log('Map constructor - Error GoogleMapsLoader:', exception);
    }

    return this;
  }

  setCurrentPlace(name, coordinates) {
    this.addMarker({coordinates, image: 'pin', name});
    this.addBound(coordinates);
  }

  setCurrentStore(name, coordinates) {
    this.addMarker({coordinates, image: 'marker-current', name});
    this.addBound(coordinates);
  }

  setStoresNearby(stores) {
    return new Promise((resolve, reject) => {
      if (stores.length < 1) {
        reject('Stores missing');
      }

      stores.forEach((store, index) => {
        const coordinates = {
          lat: parseFloat(store.lat),
          lng: parseFloat(store.lng),
        };
        this.addBound(coordinates);

        // Delay placing
        this.addMarker({
          coordinates,
          image: `marker-${index + 1}`,
          name: store.addressLines[0],
          zIndex: stores.length - index, // From marker first/above to last/below
          onClick: () => {
            // Add redirect to store page on icon click
            window.location = getStoreUrl(store);
          },
          delay: 100 * (index + 1),
        });

        if (index === stores.length - 1) {
          resolve();
        }
      });
    });
  }

  addMarker({coordinates, image, name, zIndex, onClick, delay}) {
    GoogleMapsLoader.importLibrary('marker').then((marker) => {
      const {AdvancedMarkerElement} = marker;

      // Create marker image
      const markerImage = document.createElement("img");
      const imagePath1x =  config.imageDirectoryPath + `Icons/${image}.png`;
      const imagePath2x = config.imageDirectoryPath + `Icons/${image}@2x.png`;
      markerImage.srcset = `${imagePath1x} 1x, ${imagePath2x} 2x`;
      markerImage.src = imagePath1x;

      // Animate marker
      markerImage.classList.add('drop-marker');
      markerImage.style.setProperty('--delay-time', (delay || 0) + 'ms');

      const currentMarker = new AdvancedMarkerElement({
        map: this.googleMap,
        position: coordinates,
        content: markerImage,
        title: name,
        zIndex: zIndex || 99, // Above other markers
        gmpClickable: typeof onClick === 'function',
      });

      if (typeof onClick === 'function') {
        currentMarker.addEventListener('gmp-click', onClick);
      }

      this.markers.push(currentMarker);
    });

  }

  clearMarkers() {
    this.markers.forEach((marker) => {
      marker.setMap(null);
    });
    this.markers = [];
  }

  centerMapToBounds() {
    this.googleMap.fitBounds(this.bounds);
  }

  addBound(latLng) {
    this.bounds.extend(latLng);
  }

  clearBounds() {
    this.bounds = new this.mapsCore.LatLngBounds();
  }

  stretchMapHeight() {
    const $mapWrapper = this.$node.parents('.content-map-grid');
    $mapWrapper.addClass('js_override-map-height');
  }
}

const DefaultMap = (new Map());

export default DefaultMap;
